import { Capacitor } from "@capacitor/core";

export const ANDROID_GLASS_MODE: "refractive" | "legacy" = "refractive";

export function isNativeAppPlatform(): boolean {
  if (typeof window === "undefined") return false;
  return Capacitor.isNativePlatform();
}

export function getNativePlatform(): "ios" | "android" | "web" {
  if (!isNativeAppPlatform()) return "web";
  const platform = Capacitor.getPlatform();
  if (platform === "ios" || platform === "android") return platform;
  return "web";
}
